import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Conseguí 3 entrevistas en la primera semana. Nunca me había pasado.',
  author: 'Laura P.',
  location: 'Rosario'
}, {
  quote: 'Pedí 25% más de lo que me iban a ofrecer. El reclutador aceptó sin dudar.',
  author: 'Roberto M.',
  location: 'Buenos Aires'
}, {
  quote: 'El Tomo Anti-ATS fue el cambio más grande. Finalmente me llaman.',
  author: 'Sofía C.',
  location: 'La Plata'
}];
export function Testimonials() {
  return <section className="py-20 px-4 bg-[#112240]/50 border-y border-slate-800/50" data-id="element-234">
      <div className="max-w-6xl mx-auto" data-id="element-235">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-236">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-[#0a1628] p-8 rounded-2xl border border-slate-800 hover:border-[#d4a843]/30 transition-colors mt-[-10px] mb-[-10px]" data-id="element-237">
              <div className="flex gap-1 mt-[-15px] mb-[-15px] flex-row items-start justify-start" data-id="element-238">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-[#d4a843] text-[#d4a843]" data-id="element-239" />)}
              </div>
              <p className="text-slate-200 font-medium italic text-[16px] mt-[60px] mb-[60px]" data-id="element-240">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3" data-id="element-241">
                <div className="w-10 h-10 rounded-full bg-[#112240] flex items-center justify-center text-[#d4a843] font-bold border border-[#d4a843]/20" data-id="element-242">
                  {t.author.charAt(0)}
                </div>
                <div data-id="element-243">
                  <p className="font-bold text-white text-sm" data-id="element-244">{t.author}</p>
                  <p className="text-xs text-slate-400" data-id="element-245">{t.location}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}